import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from "../../services/SecurityServices/authentication.service";
import { AppState } from '../../app.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from "../../services/Common/alert.service";
import { PermissionService } from "../../services/SecurityServices/permission.service";

@Component({
    selector: 'login',
    template: require('./login.template.html')
})
export class LoginComponent implements OnInit {
    public dt = new Date();
    Username: string;
    Password: string;
    returnUrl: string;
    loginError: string;
    submitted: boolean;
    private loginImage: string;

    constructor(
        private authService: AuthenticationService,
        private appState: AppState,
        private router: Router,
        private alertService: AlertService,
        private route: ActivatedRoute,
        private permissionService: PermissionService
    ) {
    }

    ngOnInit() {
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

        if (this.route.snapshot.queryParams['logout'] == "true") {
            this.appState.removeAllCookies();
            this.permissionService.permissionNames = new Array<string>();
        }

        this.loginImage = `../../../assets/images/${process.env.program}/login-logo.png`
    }

    login() {
        this.submitted = true;

        this.authService.login(this.Username, this.Password).subscribe(
            data => {
                this.appState.setCookie('authToken', data.access_token);
                this.authService.setUserInfoCookie();
                this.router.navigate([this.returnUrl]);
            },
            error => {
                this.loginError = "Failed to log in, invalid username or password provided.";
            }
        );
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/account/login.component.ts